class VariantUpdate extends HTMLElement {
  constructor() {
    super();
    this.selectors = this.querySelectorAll('[data-select-option]');
    this.product = JSON.parse(this.querySelector('[data-product]')?.textContent);
    this.key = this.dataset.initVariant;
    this.initial_variant_id = this.key.split(':')[0];
    this.qty_input = this.querySelector('[data-qty-input]');
    this.total_price_wrapper = this.querySelector('[data-total-variant-price]');
    this.price = parseInt(this.dataset.price);
    this.already_selected_msg = this.dataset.alreadSelected;
    this.select_option_msg = this.dataset.selectOption;
    this.not_available_msg = this.dataset.notAvailable;
    this.is_set_item = this.hasAttribute('data-is-set-item')? this.getAttribute('data-is-set-item') : false;
    if (this.is_set_item) {
      this.initialQuantity = parseInt(this.qty_input.value);
    }
    this.attachEventListeners.call(this);
  }

  attachEventListeners() {
    this.querySelector('[data-popup-change-option]').addEventListener('click', this.changeOption.bind(this));
    this.querySelector('[data-close-option]').addEventListener('click', this.close.bind(this));
    this.querySelector('[data-qty-wrapper]').addEventListener('click', this.qtyChange.bind(this));
  }

  qtyChange(e) {
    if (e.target.nodeName == 'A') {
      this.updatePrice()
    }
  }

  updatePrice() {
    this.total_price_wrapper.innerHTML = this.replaceNumberInString(this.total_price_wrapper.innerHTML, (parseInt(this.qty_input.value) * this.price).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  }

  changeOption() {
    if (this.is_set_item && this.initialQuantity != parseInt(this.qty_input.value)) {
      alert(this.dataset.quantityError);
    } else {
      const current_variant = this.generateVariantId();
      if (current_variant) {
        this.remove_selected_variant_add_new(current_variant);
      }
    }
  }

  remove_selected_variant_add_new(to_be_added) {
    const updates = {};
    updates[this.key] = 0;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        updates
      })
    })
    .then(this.addVariant.bind(this, to_be_added))
    .catch((error) => {
      console.error('Error:', error);
    })
  }

  addVariant(to_be_added) {
    if (to_be_added) {
      let formData = {
        'items': [{
          'id': to_be_added,
          'quantity': parseInt(this.qty_input.value)
        }]
      };
      if (this.is_set_item) {
        formData.items[0].properties = {
          '_setId': parseInt(this.is_set_item)
        }
      };
      fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(r => {
          if (r.status == 422) {
            alert(r.description);
          }
          location.reload();
        })
        .catch((error) => {
          console.error('Error:', error);
        })
    }
  }

  generateVariantId() {
    let variant_title = '';
    for (let selector of this.selectors) {
      if (selector.value == 'null') {
        alert(this.select_option_msg.replace('[option]', selector.dataset.selectOption));
        return false;
      }
      variant_title += selector.value + ' / ';
    }
    variant_title = variant_title.slice(0, -3);
    let current_variant = this.product.variants.find(variant => variant.title == variant_title);
    if(!current_variant.available) {
      alert(this.not_available_msg?.replace('[title]',current_variant.name));
      return false;
    }
    current_variant = current_variant.id;
    if (this.initial_variant_id != current_variant && cart_variants.includes(current_variant)) {
      alert(this.already_selected_msg);
      return false;
    }
    return current_variant;
  }

  close() {
    this.style.display = null;
  }

  open() {
    this.style.display = 'block';
  }

  replaceNumberInString(originalString, newNumber) {
    return originalString.replace(/[\d,]+(\.\d+)?/, newNumber);
  }
}
customElements.define('variant-update', VariantUpdate);